export default __webpack_public_path__ + "static/bc_en_1-828313b9577ad85aa4c252b18eed1dfc.mp4";